/* Constly hero: the floating, self-typing editor window from constly.com's home page, ported.
   The page ships the real screenshot as plain HTML (crawlers, no-JS and reduced-motion visitors keep it).
   After the page has loaded and gone idle, this builds the live window over the screenshot, the screenshot
   fades out underneath, and the window types a few example documents on a loop. Light theme first, a
   diagonal wipe to dark after 4 s, as on constly.com. Nothing is fetched. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var esc = function (s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
  var BLANK = { raw: '', html: '&#8203;' };
  var task = function (on, label) {
    return '<span class="task"><input type="checkbox" ' + (on ? 'checked ' : '') + 'tabindex="-1" aria-hidden="true">' + label + '</span>';
  };

  // example documents, from constly.com's hero (same content, a subset)
  var DOCS = [
    { file: 'launch-plan.md', lines: [
      { raw: '# Q3 launch plan', html: '<div class="cyw-h1">Q3 launch plan</div>', edit: ' 2026' },
      BLANK,
      { raw: 'Ship **byte-fidelity** and the new export path.', html: 'Ship <strong>byte-fidelity</strong> and the new export path.' },
      BLANK,
      { raw: '## Open items', html: '<div class="cyw-h2">Open items</div>' },
      { raw: '- [x] verify on a real corpus', html: task(true, 'verify on a real corpus') },
      { raw: '- [ ] write the changelog', html: task(false, 'write the changelog') },
      { raw: '- [ ] cut the universal build', html: task(false, 'cut the universal build') },
      BLANK,
      { raw: '> plain text in, plain text out', html: '<blockquote>plain text in, plain text out</blockquote>' },
      BLANK,
      { raw: '```ts\nconst shipping = true\n```', html: '<div class="cb"><span class="cb-lang">typescript</span><span class="kw">const</span> shipping <span class="op">=</span> <span class="num">true</span></div>' }
    ] },
    { file: 'release-flow.md', lines: [
      { raw: '# Release flow', html: '<div class="cyw-h1">Release flow</div>', edit: ' v2' },
      BLANK,
      { raw: '```mermaid\nbuild --> sign --> notarize --> ship\n```', html: '<div class="flow"><span class="node">build</span><span class="arr">&#8594;</span><span class="node">sign</span><span class="arr">&#8594;</span><span class="node">notarize</span><span class="arr">&#8594;</span><span class="node">ship</span></div>' },
      BLANK,
      { raw: 'Four steps, fully automated.', html: 'Four steps, fully automated.' }
    ] },
    { file: 'math.md', lines: [
      { raw: '# A little math', html: '<div class="cyw-h1">A little math</div>', edit: 's' },
      BLANK,
      { raw: 'Area scales with the square: $A = \\pi r^2$.', html: 'Area scales with the square: <span class="math">A = &pi;r<sup>2</sup></span>.' },
      BLANK,
      { raw: '$$ e^{i\\pi} + 1 = 0 $$', html: '<div class="math-block">e<sup>i&pi;</sup> + 1 = 0</div>' }
    ] },
    { file: 'standup.md', lines: [
      { raw: '# Standup', html: '<div class="cyw-h1">Standup</div>', edit: ', Fri' },
      BLANK,
      { raw: '- [x] shipped the export fix', html: task(true, 'shipped the export fix') },
      { raw: '- [ ] reply to the beta testers', html: task(false, 'reply to the beta testers') },
      BLANK,
      { raw: '> Keep it short.', html: '<blockquote>Keep it short.</blockquote>' }
    ] }
  ];

  var layer = function (kind) {
    return '<div class="rtw-cyw__layer rtw-cyw__layer--' + kind + '"><div class="rtw-cyw__bar"><span></span><span></span><span></span>' +
      '<b class="rtw-cyw__file"></b></div><div class="rtw-cyw__body"></div></div>';
  };

  function build(fig) {
    var w = document.createElement('div');
    w.className = 'rtw-cyw';
    w.setAttribute('aria-hidden', 'true');
    w.innerHTML = layer('light') + layer('dark') +
      '<span class="rtw-cyw__ptr"><svg viewBox="0 0 24 24" width="22" height="22"><path d="M5 3 L19 12 L12 13 L16 20.5 L13 21.8 L9 14.2 L5 17 Z" fill="#fff" stroke="#1a1a1a" stroke-width="1.2" stroke-linejoin="round"/></svg></span>';
    fig.appendChild(w);
    return w;
  }

  function run(media) {
    var fig = media.querySelector('.rtw-cy__frame');
    if (!fig || media.classList.contains('is-live')) return;
    var win = build(fig);
    var bodies = [].slice.call(win.querySelectorAll('.rtw-cyw__body'));
    var files = [].slice.call(win.querySelectorAll('.rtw-cyw__file'));
    var ptr = win.querySelector('.rtw-cyw__ptr');
    var set = function (i, html) { bodies.forEach(function (b) { b.children[i].innerHTML = html; }); };
    var done = function (i) { bodies.forEach(function (b) { b.children[i].className = 'ed done'; }); };

    async function editBeat(doc) {
      var head = doc.lines[0];
      var ref = bodies[0].firstElementChild;
      if (!ref) return;
      ptr.style.left = ref.offsetLeft + 54 + 'px';
      ptr.style.top = ref.offsetTop + ref.offsetHeight * 0.5 + 34 + 'px';
      ptr.classList.add('show');
      await sleep(760);
      ptr.classList.add('press'); await sleep(160); ptr.classList.remove('press');
      var text = head.raw.replace(/^#\s*/, ''), edit = head.edit || '';
      var h = function (t, caret) { return '<div class="cyw-h1"><span class="mk"># </span>' + esc(t) + (caret ? '<span class="caret"></span>' : '') + '</div>'; };
      set(0, h(text, true)); await sleep(440);
      for (var c = 1; c <= edit.length; c++) { set(0, h(text + edit.slice(0, c), true)); await sleep(105); }
      await sleep(680);
      ptr.style.top = ref.offsetTop + ref.offsetHeight * 3 + 34 + 'px';
      ptr.classList.remove('show');
      set(0, '<div class="cyw-h1">' + esc(text + edit) + '</div>');
      await sleep(520);
    }

    async function loop() {
      for (var d = 0; ; d = (d + 1) % DOCS.length) {
        var doc = DOCS[d];
        files.forEach(function (f) { f.textContent = doc.file; });
        bodies.forEach(function (b) { b.innerHTML = ''; });
        for (var i = 0; i < doc.lines.length; i++) {
          var step = doc.lines[i];
          bodies.forEach(function (b) { var l = document.createElement('div'); l.className = 'ed'; b.appendChild(l); });
          if (!step.raw) { set(i, step.html); done(i); await sleep(110); continue; }
          for (var c = 1; c <= step.raw.length; c++) { set(i, esc(step.raw.slice(0, c)) + '<span class="caret"></span>'); await sleep(26 + Math.random() * 30); }
          await sleep(330);
          set(i, step.html); done(i);
          await sleep(190);
        }
        await editBeat(doc);
        await sleep(2400);
      }
    }

    requestAnimationFrame(function () {
      media.classList.add('is-live');
      loop();
      setTimeout(function () { win.classList.add('to-dark'); }, 4000);
    });
  }

  function start() {
    var go = function () { document.querySelectorAll('.rtw-cy__media[data-live]').forEach(run); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 600);
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
